export const QUIZ_TRANSLATIONS: Record<string, Record<string, string>> = {
    en: {
        digitalQuizEvent: "Digital Quiz Event",
        dailyFootballQuiz: "DAILY FOOTBALL QUIZ",
        quizSubtitle: "Answer 10 fast-paced questions designed to test your football masterclass. Score 80% or more to earn 1 Official Sticker Pack today!",
        aiBotActive: "AI Bot Agent Active",
        curatingTrivia: "CURATING FRESH TRIVIA",
        loaderDesc: "Analyzing transfers, player stats, and championships to craft 10 brand-new, ultra-accurate daily questions. Get ready!",
        readyTitle: "Are you ready to test your skills?",
        questionsTitle: "10 Questions:",
        questionsDesc: "Hand-crafted multi-choice trivia, True or False, player identifiers, and historical club transfer timelines.",
        timerTitle: "10-Sec Timer:",
        timerDesc: "Relentless countdown for every question! Think, react, and submit before your time expires.",
        rewardsTitle: "Elite Rewards:",
        rewardsDesc: "Secure at least 8 correct answers (8/10) to win 1 collectible sticker pack. Playable daily!",
        todayStatus: "TODAY'S STATUS",
        rewardedStatus: "🎉 REWARDED (+1 PACK)",
        completedStatus: "COMPLETED",
        alreadyDoneDesc: "You have already completed today's daily quiz challenge. Live countdown triggers next question set in UTC server timezone.",
        practiceRun: "Practice Run (No Extra Packs)",
        initiateQuiz: "INITIATE TODAY'S QUIZ",
        questionTracker: "QUESTION TRACKER",
        timeRemaining: "TIME SEC REMAINING",
        type: "Type",
        multipleChoice: "Multiple Choice",
        trueOrFalse: "True Or False",
        playerSilhouette: "Player Silhouette",
        clubTransferLine: "Club Transfer Line",
        playerAchievementsProfile: "PLAYER ACHIEVEMENTS PROFILE",
        seniorTransferHistory: "SENIOR TRANSFER HISTORY",
        excellentAnswer: "EXCELLENT ANSWER (+10 POINTS)",
        timerExpired: "TIMER EXPIRED! ANSWER WAS",
        wrongAnswer: "WRONG ANSWER! ANSWER WAS",
        challengeConquered: "CHALLENGE CONQUERED!",
        challengeCompleted: "CHALLENGE COMPLETED",
        date: "DATE",
        yourPointsEarned: "YOUR POINTS EARNED",
        correctAnswers: "{correctCount} Correct Answers / 10",
        correctAnswersSingular: "{correctCount} Correct Answer / 10",
        rewardUnlockedTitle: "REWARD CREDITED UNLOCKED!",
        rewardUnlockedDesc: "Guaranteed high accuracy reached! +1 Premium Sticker Pack has been automatically added to your cabinet. Roll to the shop or click unbox to open it now!",
        rewardOnePerDayNote: "* Note: Only one stickers reward pack is credited per day. Let's return tomorrow for another football trivia round!",
        underThresholdTitle: "UNDER ACCURACY THRESHOLD",
        underThresholdDesc: "You answered {correctCount} questions correctly. A minimum of 8 correct answers (80%) is required to unlock today's free sticker pack reward.",
        underThresholdNote: "No limits on learning! Review the football facts and click retry below to test yourself and earn that sticker pack!",
        sharedSuccess: "SHARED SUCCESSFULLY!",
        copiedClipboard: "COPIED TO CLIPBOARD",
        directShare: "DIRECT SHARE RESULTS",
        retryQuiz: "RETRY FOOTBALL QUIZ",
        bonusClaimed: "🎁 BONUS CLAIMED: +1 Pack added today!",
        bonusOffer: "🎁 BONUS: Share results to claim +1 extra Pack!",
        comeBackTomorrow: "Come back tomorrow for a new daily draft!",
        quizLeaderboard: "QUIZ LEADERBOARD",
        liveRankings: "Live Rankings & Historic Champion Records",
        refreshStats: "Refresh Stats",
        loading: "Loading...",
        todaysRanks: "Today's Ranks",
        allTimeRecords: "All-Time Records",
        searchCollectors: "SEARCH COLLECTORS...",
        retrievingLeaderboard: "Retrieving live leaderboard rankings...",
        noMatchedPlayers: "No matched players found in the system.",
        nobodySubmitted: "Nobody has submitted daily score cards yet today. Ace the challenge & secure your podium!",
        noRankings: "No ranking entries recorded.",
        you: "You",
        eventsSolved: "Events Solved",
        eventsSolvedSingular: "Event Solved",
        eventsSolvedPlural: "Events Solved",
        todaysPoints: "TODAY'S POINTS",
        totalPoints: "TOTAL POINTS",
        confirmResetProgress: "Are you sure you want to completely reset today's progress & daily matching record?",
        yesReset: "YES, RESET",
        cancel: "CANCEL",
        resetBtn: "🧪 RESET TODAY'S DRIFT PROGRESS (TEST)",
        badgeTextSuccess: "🏅 CHALLENGE CONQUERED! (+1 Sticker Pack Unlocked)",
        badgeTextFailure: "⚡ Learning the legends! Practice makes perfect.",
        correctAnswersShort: "Correct"
    },
    es: {
        digitalQuizEvent: "Evento de Quiz Digital",
        dailyFootballQuiz: "QUIZ DE FÚTBOL DIARIO",
        quizSubtitle: "Responde 10 preguntas rápidas diseñadas para poner a prueba tu maestría futbolística. ¡Consigue un 80% o más para ganar 1 Sobre de Cromos Oficial hoy!",
        aiBotActive: "Agente Bot de IA Activo",
        curatingTrivia: "CREANDO PREGUNTAS NUEVAS",
        loaderDesc: "Analizando fichajes, estadísticas de jugadores y campeonatos para diseñar 10 preguntas diarias completamente nuevas y ultra precisas. ¡Prepárate!",
        readyTitle: "¿Estás listo para probar tus habilidades?",
        questionsTitle: "10 Preguntas:",
        questionsDesc: "Trivia de opción múltiple hecha a mano, Verdadero o Falso, indentificadores de jugador e historiales de transferencia de clubes.",
        timerTitle: "Temporizador de 10s:",
        timerDesc: "¡Cuenta regresiva sin tregua para cada pregunta! Piensa, reacciona y envía antes de que expire el tiempo.",
        rewardsTitle: "Recompensas de Élite:",
        rewardsDesc: "¡Asegura al menos 8 respuestas correctas (8/10) para ganar 1 sobre de cromos coleccionables. ¡Jugable diariamente!",
        todayStatus: "ESTADO DE HOY",
        rewardedStatus: "🎉 RECOMPENSADO (+1 SOBRE)",
        completedStatus: "COMPLETADO",
        alreadyDoneDesc: "Ya completaste el desafío del quiz diario de hoy. Un nuevo conjunto de preguntas se activará según la zona horaria del servidor UTC.",
        practiceRun: "Práctica de Entrenamiento (Sin sobres extra)",
        initiateQuiz: "INICIAR EL QUIZ DE HOY",
        questionTracker: "PROGRESO DE PREGUNTAS",
        timeRemaining: "TIEMPO RESTANTE (SEG)",
        type: "Tipo",
        multipleChoice: "Opción Múltiple",
        trueOrFalse: "Verdadero o Falso",
        playerSilhouette: "Silueta del Jugador",
        clubTransferLine: "Línea de Traspaso del Club",
        playerAchievementsProfile: "PERFIL DE LOGROS DEL JUGADOR",
        seniorTransferHistory: "HISTORIAL DE TRASPASOS SÉNIOR",
        excellentAnswer: "¡EXCELENTE RESPUESTA! (+10 PUNTOS)",
        timerExpired: "¡TIEMPO EXPIRADO! LA RESPUESTA ERA",
        wrongAnswer: "¡RESPUESTA INCORRECTA! LA RESPUESTA ERA",
        challengeConquered: "¡DESAFÍO CONQUISTADO!",
        challengeCompleted: "DESAFÍO COMPLETADO",
        date: "FECHA",
        yourPointsEarned: "TUS PUNTOS OBTENIDOS",
        correctAnswers: "{correctCount} Respuestas Correctas / 10",
        correctAnswersSingular: "{correctCount} Respuesta Correcta / 10",
        rewardUnlockedTitle: "¡RECOMPENSA DESBLOQUEADA Y ACREDITADA!",
        rewardUnlockedDesc: "¡Precisión garantizada alcanzada! Se ha añadido automáticamente +1 Sobre de Cromos Premium a tu colección. ¡Ve a la tienda o haz clic en abrir sobres para abrirlo ahora!",
        rewardOnePerDayNote: "* Nota: Solo se acredita un sobre de recompensa por día. ¡Vuelve mañana para otra ronda de preguntas de fútbol!",
        underThresholdTitle: "BAJO EL UMBRAL DE PRECISIÓN",
        underThresholdDesc: "Respondiste {correctCount} preguntas correctamente. Se requiere un mínimo de 8 respuestas correctas (80%) para desbloquear el sobre gratis de hoy.",
        underThresholdNote: "¡El aprendizaje no tiene límites! Revisa los datos de fútbol y haz clic en reintentar abajo para ponerte a prueba y ganar ese sobre.",
        sharedSuccess: "¡COMPARTIDO CON ÉXITO!",
        copiedClipboard: "COPIADO AL PORTAPAPELES",
        directShare: "COMPARTIR RESULTADOS DIRECTAMENTE",
        retryQuiz: "REINTENTAR QUIZ DE FÚLUBLA",
        bonusClaimed: "🎁 BONO RECLAMADO: ¡+1 Sobre añadido hoy!",
        bonusOffer: "🎁 BONO: ¡Comparte los resultados para reclamar +1 sobre extra!",
        comeBackTomorrow: "¡Vuelve mañana para un nuevo desafío diario!",
        quizLeaderboard: "TABLA DE CLASIFICACIÓN",
        liveRankings: "Clasificación en vivo e historial de campeones",
        refreshStats: "Actualizar datos",
        loading: "Cargando...",
        todaysRanks: "Clasificación de hoy",
        allTimeRecords: "Récords históricos",
        searchCollectors: "BUSCAR COLECCIONISTAS...",
        retrievingLeaderboard: "Recuperando clasificación de la tabla en vivo...",
        noMatchedPlayers: "No se encontraron jugadores que coincidan.",
        nobodySubmitted: "Nadie ha enviado puntuaciones hoy todavía. ¡Supera el desafío y asegura tu podio!",
        noRankings: "No hay clasificaciones registradas.",
        you: "Tú",
        eventsSolved: "Eventos Resueltos",
        eventsSolvedSingular: "Evento Resuelto",
        eventsSolvedPlural: "Eventos Resueltos",
        todaysPoints: "PUNTOS DE HOY",
        totalPoints: "PUNTOS TOTALES",
        confirmResetProgress: "¿Estás seguro de que quieres restablecer tu progreso de hoy y el registro diario?",
        yesReset: "SÍ, RESTABLECER",
        cancel: "CANCELAR",
        resetBtn: "🧪 RESTABLECER PROGRESO DE HOY (PRUEBA)",
        badgeTextSuccess: "🏅 ¡DESAFÍO CONQUISTADO! (+1 Sobre de Cromos Desbloqueado)",
        badgeTextFailure: "⚡ ¡Aprendiendo de las leyendas! La práctica hace al maestro.",
        correctAnswersShort: "Correctas"
    },
    pt: {
        digitalQuizEvent: "Evento de Quiz Digital",
        dailyFootballQuiz: "QUIZ DIÁRIODE FUTEBOL",
        quizSubtitle: "Responda a 10 perguntas rápidas para testar seu conhecimento. Marque 80% ou mais para ganhar 1 Pacote de Figurinhas Oficial hoje!",
        aiBotActive: "Agente Bot de IA Ativo",
        curatingTrivia: "CRIANDO PERGUNTAS NOVAS",
        loaderDesc: "Analisando transferências, estatísticas de jogadores e campeonatos para criar 10 perguntas diárias inéditas e ultraprecisas. Prepare-se!",
        readyTitle: "Você está pronto para testar suas habilidades?",
        questionsTitle: "10 Perguntas:",
        questionsDesc: "Perguntas de múltipla escolha, Verdadeiro ou Falso, pistas com emojis dos jogadores e históricos de transferências.",
        timerTitle: "Timer de 10s:",
        timerDesc: "Contagem regressiva impiedosa! Pense rápido e responda antes que o tempo acabe.",
        rewardsTitle: "Anfitrião de Prêmios:",
        rewardsDesc: "Garanta pelo menos 8 respostas corretas (8/10) para ganhar um pacote de figurinhas grátis. Jogue diariamente!",
        todayStatus: "STATUS DE HOJE",
        rewardedStatus: "🎉 RECOMPENSADO (+1 PACOTE)",
        completedStatus: "COMPLETADO",
        alreadyDoneDesc: "Você já concluiu o desafio do quiz de hoje. Um novo conjunto de perguntas será iniciado com base no fuso horário do servidor UTC.",
        practiceRun: "Treino de Prática (Sem pacotes extras)",
        initiateQuiz: "INICIAR O QUIZ DE HOJE",
        questionTracker: "RASTREADOR DE PERGUNTAS",
        timeRemaining: "TEMPO RESTANTE (SEG)",
        type: "Tipo",
        multipleChoice: "Múltipla Escolha",
        trueOrFalse: "Verdadero ou Falso",
        playerSilhouette: "Silhueta do Jogador",
        clubTransferLine: "Histórico de Clubes",
        playerAchievementsProfile: "PERFIL DE CONQUISTAS DO JOGADOR",
        seniorTransferHistory: "HISTÓRICO SÊNIOR DE TRANSFERÊNCIAS",
        excellentAnswer: "EXCELENTE RESPOSTA! (+10 PONTOS)",
        timerExpired: "TEMPO ESGOTADO! A RESPOSTA ERA",
        wrongAnswer: "RESPOSTA INCORRETA! A RESPOSTA ERA",
        challengeConquered: "DESAFIO CONQUISTADO!",
        challengeCompleted: "DESAFIO COMPLETADO",
        date: "DATA",
        yourPointsEarned: "SEUS PONTOS GANHOS",
        correctAnswers: "{correctCount} Respostas Corretas / 10",
        correctAnswersSingular: "{correctCount} Resposta Correta / 10",
        rewardUnlockedTitle: "RECOMPENSA DESBLOQUEADA!",
        rewardUnlockedDesc: "Precisão alcançada! +1 Pacote de Figurinhas Premium foi adicionado. Abra seus pacotes agora!",
        rewardOnePerDayNote: "* Nota: Apenas um pacote de bônus por dia. Volte amanhã para mais desafios!",
        underThresholdTitle: "ABAIXO DO LIMITE NECESSÁRIO",
        underThresholdDesc: "Você acertou {correctCount} perguntas. É preciso no mínimo 8 de 10 para o pacote grátis.",
        underThresholdNote: "Sem limites para aprender! Reveja os dados do jogo e jogue de novo para conseguir o pacote!",
        sharedSuccess: "COMPARTILHADO COM SUCESSO!",
        copiedClipboard: "COPIADO PARA A ÁREA DE TRANSFERÊNCIA",
        directShare: "COMPARTILHAR RESULTADOS DIRETAMENTE",
        retryQuiz: "REPETIR QUIZ DE FUTEBOL",
        bonusClaimed: "🎁 BÔNUS RESGATADO: +1 Pacote adicionado!",
        bonusOffer: "🎁 BÔNUS: Compartilhe o placar para ganhar +1 pacote!",
        comeBackTomorrow: "Volte amanhã para novas figurinhas e perguntas!",
        quizLeaderboard: "TABLA DE LIDERANÇA",
        liveRankings: "Ranqueamento ao vivo & Registros Históricos",
        refreshStats: "Atualizar Estatísticas",
        loading: "Carregando...",
        todaysRanks: "Ranque de Hoje",
        allTimeRecords: "Registros de Sempre",
        searchCollectors: "BUSCAR COLECIONADORES...",
        retrievingLeaderboard: "Atualizando tabela de classificação real...",
        noMatchedPlayers: "Nenhum colecionador encontrado.",
        nobodySubmitted: "Ninguém enviou resultados hoje ainda. Seja o primeiro!",
        noRankings: "Sem registros ainda.",
        you: "Você",
        eventsSolved: "Desafios Resolvidos",
        eventsSolvedSingular: "Desafio Resolvido",
        eventsSolvedPlural: "Desafios Resolvidos",
        todaysPoints: "PONTOS DE HOJE",
        totalPoints: "PONTOS TOTAIS",
        confirmResetProgress: "Tem certeza que deseja apagar os registros de hoje?",
        yesReset: "SIM, RESETAR",
        cancel: "CANCELAR",
        resetBtn: "🧪 RESETAR PROGRESSO DE HOJE (TESTE)",
        badgeTextSuccess: "🏅 DESAFIO CONQUISTADO! (+1 Pacote de Adesivos Desbloqueado)",
        badgeTextFailure: "⚡ Aprendendo com as lendas! A prática leva à perfeição.",
        correctAnswersShort: "Corretas"
    },
    fr: {
        digitalQuizEvent: "Événement Quiz Digital",
        dailyFootballQuiz: "QUIZ DE FOOTBALL QUOTIDIEN",
        quizSubtitle: "Répondez à 10 questions rapides pour tester votre maîtrise du football. Marquez 80% ou plus pour gagner 1 Paquet de Stickers Officiel aujourd'hui !",
        aiBotActive: "Agent Bot IA Actif",
        curatingTrivia: "CRÉATION DE QUESTIONS FRAÎCHES",
        loaderDesc: "Analyse des transferts, des statistiques de joueurs et des championnats pour concevoir 10 questions inédites et ultra-précises. Préparez-vous !",
        readyTitle: "Êtes-vous prêt à tester vos compétences ?",
        questionsTitle: "10 Questions :",
        questionsDesc: "Questions à choix multiples, Vrai ou Faux, indices émoji des joueurs et historiques des transferts en club.",
        timerTitle: "Timer de 10s :",
        timerDesc: "Compte à rebours impitoyable ! Réfléchissez vite et validez avant que le temps ne s'écoule.",
        rewardsTitle: "Récompenses d'Élite :",
        rewardsDesc: "Obtenez au moins 8 bonnes réponses (8/10) pour remporter un paquet de stickers. Jouable quotidiennement !",
        todayStatus: "STATUT DU JOUR",
        rewardedStatus: "🎉 RÉCOMPENSÉ (+1 PAQUET)",
        completedStatus: "TERMINÉ",
        alreadyDoneDesc: "Vous avez déjà terminé le quiz d'aujourd'hui. Un nouvel ensemble de questions commencera bientôt d'après l'heure UTC.",
        practiceRun: "Mode Entraînement (Sans paquet bonus)",
        initiateQuiz: "LANCER LE QUIZ DU JOUR",
        questionTracker: "PROGRÈS DU QUIZ",
        timeRemaining: "TEMPS RESTANT (SEC)",
        type: "Type",
        multipleChoice: "Choix Multiples",
        trueOrFalse: "Vrai ou Faux",
        playerSilhouette: "Silhouette de Joueur",
        clubTransferLine: "Ligne de Transfert de Club",
        playerAchievementsProfile: "PROFIL DES SUCCÈS DU JOUEUR",
        seniorTransferHistory: "HISTORIQUE DES TRANSFERTS SÉNIOR",
        excellentAnswer: "EXCELLENTE RÉPONSE ! (+10 POINTS)",
        timerExpired: "TEMPS ÉCOULÉ ! LA RÉPONSE ÉTAIT",
        wrongAnswer: "MAUVAISE RÉPONSE ! LA RÉPONSE ÉTAIT",
        challengeConquered: "DÉFI SURMONTÉ !",
        challengeCompleted: "DÉFI TERMINÉ",
        date: "DATE",
        yourPointsEarned: "VOS POINTS GAGNÉS",
        correctAnswers: "{correctCount} Réponses Correctes / 10",
        correctAnswersSingular: "{correctCount} Réponse Correcte / 10",
        rewardUnlockedTitle: "RECOMPENSE DÉBLOQUÉE !",
        rewardUnlockedDesc: "Félicitations pour votre précision ! +1 Paquet de Stickers Premium a été ajouté à votre collection.",
        rewardOnePerDayNote: "* Note: Un seul paquet bonus par jour est disponible. Revenez demain pour un nouveau quiz !",
        underThresholdTitle: "SOUS LE SEUIL REQUIS",
        underThresholdDesc: "Vous avez répondu correctement à {correctCount} questions. Un minimum de 8 réponses est requis pour remporter le paquet.",
        underThresholdNote: "Pas de limites à l'apprentissage ! Révisez les faits et réessayez pour gagner votre paquet de stickers !",
        sharedSuccess: "PARTAGÉ AVEC SUCCÈS !",
        copiedClipboard: "COPIÉ DANS LE PRESSE-PAPIERS",
        directShare: "PARTAGER DIRECTEMENT LES RÉSULTATS",
        retryQuiz: "RECOMMENCER LE QUIZ FOOT",
        bonusClaimed: "🎁 BONUS OBTENU: +1 Paquet ajouté !",
        bonusOffer: "🎁 BONUS: Partagez vos résultats pour débloquer +1 paquet supplémentaire !",
        comeBackTomorrow: "Revenez demain pour une nouvelle draft quotidienne !",
        quizLeaderboard: "CLASSEMENT DU QUIZ",
        liveRankings: "Classements en Direct & Records Historiques",
        refreshStats: "Actualiser les Stats",
        loading: "Chargement...",
        todaysRanks: "Classement d'Aujourd'hui",
        allTimeRecords: "Records Globaux",
        searchCollectors: "RECHERCHER UN JOUEUR...",
        retrievingLeaderboard: "Mise à jour du classement en direct...",
        noMatchedPlayers: "Aucun collectionneur trouvé.",
        nobodySubmitted: "Personne n'a encore soumis de score aujourd'hui. Soyez le premier !",
        noRankings: "Aucun classement enregistré.",
        you: "Vous",
        eventsSolved: "Événements Résolus",
        eventsSolvedSingular: "Événement Résolu",
        eventsSolvedPlural: "Événements Résolus",
        todaysPoints: "POINTS DU JOUR",
        totalPoints: "TOTAL DES POINTS",
        confirmResetProgress: "Êtes-vous sûr de vouloir réinitialiser vos progrès d'aujourd'hui ?",
        yesReset: "OUI, RÉINITIALISER",
        cancel: "ANNULER",
        resetBtn: "🧪 RÉINITIALISER LES PROGRÈS D'AUJOURD'HUI",
        badgeTextSuccess: "🏅 DÉFI DE FOOTBALL REMPORTÉ ! (+1 Paquet de Stickers Débloqué)",
        badgeTextFailure: "⚡ On apprend des légendes ! C'est en forgeant qu'on devient forgeron.",
        correctAnswersShort: "Correctes"
    },
    de: {
        digitalQuizEvent: "Digitales Quiz-Event",
        dailyFootballQuiz: "TÄGLICHES FUSSBALL-QUIZ",
        quizSubtitle: "Beantworten Sie 10 schnelle Fragen, um Ihr Fußballwissen zu testen. Erreichen Sie 80 % oder mehr, um heute 1 offizielles Sticker-pack zu erhalten!",
        aiBotActive: "KI-Bot-Agent Aktiv",
        curatingTrivia: "NEUE FRAGEN WERDEN ERSTELLT",
        loaderDesc: "Analysiere Transfers, Spielerstatistiken und Meisterschaften, um 10 neue, präzise tägliche Fragen zu erstellen. Mach dich bereit!",
        readyTitle: "Bist du bereit, dein Können zu testen?",
        questionsTitle: "10 Fragen:",
        questionsDesc: "Zufällige Multiple-Choice-Fragen, Richtig oder Falsch, Spieleridentifikatoren und historische Transferwege.",
        timerTitle: "10-Sec Timer:",
        timerDesc: "Gnadenloser Countdown for jede Frage! Beantworte sie, bevor die Zeit abläuft.",
        rewardsTitle: "Elite-Belohnungen:",
        rewardsDesc: "Beantworte mindestens 8 Fragen richtig (8/10), um ein Sticker-pack zu gewinnen. Täglich spielbar!",
        todayStatus: "HEUTIGER STATUS",
        rewardedStatus: "🎉 BELOHNT (+1 PACK)",
        completedStatus: "ABGESCHLOSSEN",
        alreadyDoneDesc: "Du hast das heutige Quiz bereits abgeschlossen. Neue Fragen starten gemäß der UTC-Serverzeit.",
        practiceRun: "Übungsrunde (Keine Bonus-Packs)",
        initiateQuiz: "HEUTIGES QUIZ STARTEN",
        questionTracker: "FRAGE-PROGESS",
        timeRemaining: "VERBLEIBENDE ZEIT",
        type: "Typ",
        multipleChoice: "Multiple-Choice",
        trueOrFalse: "Richtig oder Falsch",
        playerSilhouette: "Spieler-Silhouette",
        clubTransferLine: "Transferhistorie",
        playerAchievementsProfile: "SPIELER-ERFOLGSPROFIL",
        seniorTransferHistory: "SENIOR-TRANSFERHISTORIE",
        excellentAnswer: "HERVORRAGENDE ANTWORT! (+10 PUNKTE)",
        timerExpired: "ZEIT ABGELAUFEN! DIE ANTWORT WAR",
        wrongAnswer: "FALSCHE ANTWORT! DIE ANTWORT WAR",
        challengeConquered: "HERAUSFORDERUNG MEISTERT!",
        challengeCompleted: "HERAUSFORDERUNG BEENDET",
        date: "DATUM",
        yourPointsEarned: "IHRE ERZIELTEN PUNKTE",
        correctAnswers: "{correctCount} Richtige Antworten / 10",
        correctAnswersSingular: "{correctCount} Richtige Antwort / 10",
        rewardUnlockedTitle: "BELOHNUNG FREIGESCHALTET!",
        rewardUnlockedDesc: "Erfolgreich gelöst! +1 Premium-Sticker-pack wurde automatisch deiner Sammlung hinzugefügt. Geh in den Shop oder öffne Packs, um es jetzt zu öffnen!",
        rewardOnePerDayNote: "* Hinweis: Nur ein Sticker-pack pro Tag verfügbar. Komm morgen wieder für mehr Trivia!",
        underThresholdTitle: "UNTER DER GENAUIGKEITSGRENZE",
        underThresholdDesc: "Du hast {correctCount} Fragen richtig beantwortet. Mindestens 8 richtige Antworten sind erforderlich.",
        underThresholdNote: "Lernen kennt keine Grenzen! Schau dir die Fakten an und versuche es erneut, um das Pack freizuschalten!",
        sharedSuccess: "ERFOLGREICH GETEILT!",
        copiedClipboard: "IN DIE ZWISCHENABLAGE KOPIERT",
        directShare: "ERGEBNISSE DIREKT TEILEN",
        retryQuiz: "QUIZ ERNEUT VERSUCHEN",
        bonusClaimed: "🎁 BONUS BEANSPRUCHT: +1 Pack hinzugefügt!",
        bonusOffer: "🎁 BONUS: Ergebnisse teilen für +1 extra Pack!",
        comeBackTomorrow: "Komm morgen für ein neues tägliches Quiz wieder!",
        quizLeaderboard: "QUIZ-BESTENLISTE",
        liveRankings: "Live-Rankings & Historische Bestmarken",
        refreshStats: "Statistiken aktualisieren",
        loading: "Lade...",
        todaysRanks: "Heutige Ränge",
        allTimeRecords: "Allzeit-Rekorde",
        searchCollectors: "SAMMLER SUCHEN...",
        retrievingLeaderboard: "Lade aktuelle Bestenliste...",
        noMatchedPlayers: "Keine übereinstimmenden Spieler gefunden.",
        nobodySubmitted: "Heute wurden noch keine Ergebnisse eingereicht. Klettere jetzt aufs Podium!",
        noRankings: "Keine Ranking-Einträge vorhanden.",
        you: "Du",
        eventsSolved: "Events Gelöst",
        eventsSolvedSingular: "Event Gelöst",
        eventsSolvedPlural: "Events Gelöst",
        todaysPoints: "HEUTIGE PUNKTE",
        totalPoints: "GESAMTPUNKTE",
        confirmResetProgress: "Bist du dir sicher, dass du deinen heutigen Fortschritt löschen möchtest?",
        yesReset: "JA, ZURÜCKSETZEN",
        cancel: "ABBRECHEN",
        resetBtn: "🧪 HEUTIGEN FORTSCHRITT LÖSCHEN (TEST)",
        badgeTextSuccess: "🏅 HERAUSFORDERUNG GEWONNEN! (+1 Sticker-pack freigeschaltet)",
        badgeTextFailure: "⚡ Meister lernen von Legenden! Übung macht den Meister.",
        correctAnswersShort: "Richtig"
    },
    it: {
        digitalQuizEvent: "Evento Quiz Digitale",
        dailyFootballQuiz: "QUIZ GIORNALIERO DI CALCIO",
        quizSubtitle: "Rispondi a 10 domande veloci per mettere alla prova la tua cultura calcistica. Ottieni l'80% o più per vincere oggi 1 Pacchetto di Figurine Ufficiale!",
        aiBotActive: "Agente Bot IA Attivo",
        curatingTrivia: "CREAZIONE DI NUOVE DOMANDE",
        loaderDesc: "Analizziamo trasferimenti, statistiche dei giocatori e campionati per creare 10 domande giornaliere nuove e ultra-precise. Preparati!",
        readyTitle: "Sei pronto a metterti alla prova?",
        questionsTitle: "10 Domande:",
        questionsDesc: "Domande a scelta multipla, Vero o Falso, sagome di giocatori e cronologia dei trasferimenti.",
        timerTitle: "Timer di 10s:",
        timerDesc: "Conto alla rovescia implacabile per ogni domanda! Pensa, reagisci e invia prima della scadenza.",
        rewardsTitle: "Premi d'Élite:",
        rewardsDesc: "Indovina almeno 8 risposte corrette (8/10) per vincere 1 pacchetto di figurine. Giocabile ogni giorno!",
        todayStatus: "STATO DI OGGI",
        rewardedStatus: "🎉 RICOMPENSATO (+1 PACCHETTO)",
        completedStatus: "COMPLETATO",
        alreadyDoneDesc: "Hai già completato il quiz di oggi. Un nuovo set di domande si attiverà presto in base al fuso orario UTC.",
        practiceRun: "Gara di Pratica (Nessun pacchetto extra)",
        initiateQuiz: "INIZIA IL QUIZ DI OGGI",
        questionTracker: "PROGRESSO DOMANDE",
        timeRemaining: "TEMPO RIMANENTE (SEC)",
        type: "Tipo",
        multipleChoice: "Scelta Multipla",
        trueOrFalse: "Vero o Falso",
        playerSilhouette: "Sagoma del Giocatore",
        clubTransferLine: "Storia dei Trasferimenti",
        playerAchievementsProfile: "PROFILO PALMARÈS DEL GIOCATORE",
        seniorTransferHistory: "CRONOLOGIA TRASFERIMENTI",
        excellentAnswer: "RISPOSTA ECCELLENTE! (+10 PUNTI)",
        timerExpired: "TEMPO SCADUTO! LA RISPOSTA ERA",
        wrongAnswer: "RISPOSTA ERRATA! LA RISPOSTA ERA",
        challengeConquered: "SFIDA CONQUISTATA!",
        challengeCompleted: "SFIDA COMPLETATA",
        date: "DATA",
        yourPointsEarned: "I TUOI PUNTI GUADAGNATI",
        correctAnswers: "{correctCount} Risposte Corrette / 10",
        correctAnswersSingular: "{correctCount} Risposta Corretta / 10",
        rewardUnlockedTitle: "PREMIO SBLOCCATO E ACCREDITATO!",
        rewardUnlockedDesc: "Precisione eccellente raggiunta! +1 Pacchetto di Figurine Premium è stato aggiunto alla tua collezione.",
        rewardOnePerDayNote: "* Nota: È disponibile solo un pacchetto premio al giorno. Torna domani per un nuovo quiz!",
        underThresholdTitle: "SOTTO LA SOGLIA RICHIESTA",
        underThresholdDesc: "Hai risposto correttamente a {correctCount} domande. È richiesto un minimo di 8 risposte esatte.",
        underThresholdNote: "L'apprendimento non ha limiti! Rivedi i fatti calcistici e riprova per vincere il tuo pacchetto!",
        sharedSuccess: "CONDIVISO CON SUCCESSO!",
        copiedClipboard: "COPIATO CONDIVIDI NEGLI APPUNTI",
        directShare: "CONDIVIDI RISULTATI DIRETTAMENTE",
        retryQuiz: "RIPROVA QUIZ CALCIO",
        bonusClaimed: "🎁 BONUS RISCATTATO: +1 Pacchetto aggiunto oggi!",
        bonusOffer: "🎁 BONUS: Condividi i risultati per richiedere +1 pacchetto extra!",
        comeBackTomorrow: "Torna domani per nuove domande!",
        quizLeaderboard: "CLASSIFICA DEI QUIZ",
        liveRankings: "Classifiche in Tempo Reale & Record Storici",
        refreshStats: "Aggiorna Statistiche",
        loading: "Caricamento...",
        todaysRanks: "Classifica di Oggi",
        allTimeRecords: "Record di Tutti i Tempi",
        searchCollectors: "CERCA COLLEZIONISTI...",
        retrievingLeaderboard: "Aggiornamento classifica in corso...",
        noMatchedPlayers: "Nessun collezionista trovato.",
        nobodySubmitted: "Nessuno ha ancora inviato punteggi oggi. Sii il primo a salire sul podio!",
        noRankings: "Nessuna classifica registrata.",
        you: "Tu",
        eventsSolved: "Eventi Risolti",
        eventsSolvedSingular: "Evento Risolto",
        eventsSolvedPlural: "Eventi Risolti",
        todaysPoints: "PUNTI DI OGGI",
        totalPoints: "PUNTI TOTALI",
        confirmResetProgress: "Sei sicuro di voler resettare i progressi di oggi?",
        yesReset: "SÌ, RESETTA",
        cancel: "ANNULLA",
        resetBtn: "🧪 RESETTA PROGRESSO DI OGGI (TEST)",
        badgeTextSuccess: "🏅 SFIDA VINTA! (+1 Pacchetto figurine sbloccato)",
        badgeTextFailure: "⚡ Si impara dalle leggende! La pratica rende perfetti.",
        correctAnswersShort: "Corrette"
    },
    tr: {
        digitalQuizEvent: "Dijital Bilgi Yarışması",
        dailyFootballQuiz: "GÜNLÜK FUTBOL BİLGİ YARIŞMASI",
        quizSubtitle: "Futbol bilginizi test etmek için tasarlanmış 10 hızlı soruyu yanıtlayın. Bugün 1 Resmi Çıkartma Paketi kazanmak için %80 veya daha yüksek puan alın!",
        aiBotActive: "Yapay Zeka Bot Temsilcisi Aktif",
        curatingTrivia: "YENİ SORULAR HAZIRLANIYOR",
        loaderDesc: "Her gün 10 adet tamamen yeni, ultra doğru soru tasarlamak için transferleri, oyuncu istatistiklerini ve şampiyonaları analiz ediyoruz. Hazır olun!",
        readyTitle: "Yeteneklerinizi test etmeye hazır mısınız?",
        questionsTitle: "10 Soru:",
        questionsDesc: "El yapımı çoktan seçmeli sorular, Doğru veya Yanlış, oyuncu silüetleri ve kulüp transfer geçmişleri.",
        timerTitle: "10 Saniyelik Süre:",
        timerDesc: "Her soru için acımasız geri sayım! Süreniz dolmadan düşünün, tepki verin ve gönderin.",
        rewardsTitle: "Seçkin Ödüller:",
        rewardsDesc: "Ücretsiz bir çıkartma paketi kazanmak için en az 8 doğru yanıt (8/10) alın. Her gün oynanabilir!",
        todayStatus: "BUGÜNÜN DURUMU",
        rewardedStatus: "🎉 ÖDÜLLENDİRİLDİ (+1 PAKET)",
        completedStatus: "TAMAMLANDI",
        alreadyDoneDesc: "Bugünün günlük bilgi yarışması mücadelesini zaten tamamladınız. UTC sunucu saat dilimine göre yeni sorular yakında başlayacak.",
        practiceRun: "Pratik Yapma (Ekstra Paket Yok)",
        initiateQuiz: "BUGÜNÜN YARIŞMASINI BAŞLAT",
        questionTracker: "SORU TAKİBİ",
        timeRemaining: "KALAN SÜRE (SAN)",
        type: "Tür",
        multipleChoice: "Çoktan Seçmeli",
        trueOrFalse: "Doğru veya Yanlış",
        playerSilhouette: "Oyuncu Silüeti",
        clubTransferLine: "Kulüp Transfer Geçmişi",
        playerAchievementsProfile: "OYUNCU BAŞARI PROFİLİ",
        seniorTransferHistory: "TRANSFER GEÇMİŞİ",
        excellentAnswer: "HARİKA CEVAP! (+10 PUAN)",
        timerExpired: "SÜRE DOLDU! CEVAP ŞUYDU",
        wrongAnswer: "YANLIŞ CEVAP! CEVAP ŞUYDU",
        challengeConquered: "MÜCADELE AŞILDI!",
        challengeCompleted: "MÜCADELE TAMAMLANDI",
        date: "TARİH",
        yourPointsEarned: "KAZANDIĞINIZ PUANLAR",
        correctAnswers: "{correctCount} Doğru Cevap / 10",
        correctAnswersSingular: "{correctCount} Doğru Cevap / 10",
        rewardUnlockedTitle: "ÖDÜL KİLİDİ AÇILDI VE YÜKLENDİ!",
        rewardUnlockedDesc: "Mükemmel doğruluk oranına ulaşıldı! Koleksiyonunuza +1 Premium Çıkartma Paketi otomatik olarak eklendi.",
        rewardOnePerDayNote: "* Not: Günde sadece bir ödül paketi tanımlanır. Yeni bir futbol turu için yarın tekrar gelin!",
        underThresholdTitle: "GEREKLİ DOĞRULUK SINIRININ ALTINDA",
        underThresholdDesc: "{correctCount} soruyu doğru yanıtladınız. Ücretsiz paketi kazanmak için en az 8 doğru yanıt gereklidir.",
        underThresholdNote: "Öğrenmenin sınırı yoktur! Futbol gerçeklerini gözden geçirin ve paketi kazanmak için alttaki tekrar dene seçeneğine tıklayın!",
        sharedSuccess: "BAŞARIYLA PAYLAŞILDI!",
        copiedClipboard: "PANEYA KOPYALANDI",
        directShare: "SONUÇLARI DOĞRUDAN PAYLAŞ",
        retryQuiz: "YENİDEN DENE",
        bonusClaimed: "🎁 BONUS ALINDI: Bugün +1 Paket eklendi!",
        bonusOffer: "🎁 BONUS: +1 ekstra Paket kazanmak için sonuçları paylaşın!",
        comeBackTomorrow: "Yeni günlük sorular için yarın tekrar gelin!",
        quizLeaderboard: "BİLGİ YARIŞMASI LİDERLİK TABLOSU",
        liveRankings: "Canlı Sıralamalar ve Tarihi Rekorlar",
        refreshStats: "İstatistikleri Yenile",
        loading: "Yükleniyor...",
        todaysRanks: "Bugünün Sıralaması",
        allTimeRecords: "Tüm Zamanların Rekorları",
        searchCollectors: "KOLEKSİYONCU ARA...",
        retrievingLeaderboard: "Canlı sıralamalar güncelleniyor...",
        noMatchedPlayers: "Eşleşen koleksiyoncu bulunamadı.",
        nobodySubmitted: "Bugün henüz kimse skor göndermedi. Kürsüye çıkan ilk kişi siz olun!",
        noRankings: "Kayıtlı sıralama bulunamadı.",
        you: "Siz",
        eventsSolved: "Çözülen Yarışmalar",
        eventsSolvedSingular: "Çözülen Yarışma",
        eventsSolvedPlural: "Çözülen Yarışmalar",
        todaysPoints: "BUGÜNÜN PUANI",
        totalPoints: "TOPLAM PUAN",
        confirmResetProgress: "Bugünün ilerlemesini tamamen sıfırlamak istediğinizden emin misiniz?",
        yesReset: "EVET, SIFIRLA",
        cancel: "İPTAL",
        resetBtn: "🧪 BUGÜNÜN İLERLEMESİNİ SIFIRLA (TEST)",
        badgeTextSuccess: "🏅 MÜCADELE KAZANILDI! (+1 Çıkartma Paketi Açıldı)",
        badgeTextFailure: "⚡ Efsanelerden öğreniyoruz! Pratik yapmak mükemmelleştirir.",
        correctAnswersShort: "Doğru"
    },
    nl: {
        digitalQuizEvent: "Digitaal Quiz-evenement",
        dailyFootballQuiz: "DAGELIJKSE VOETBALQUIZ",
        quizSubtitle: "Beantwoord 10 snelle vragen om je voetbalkennis te testen. Scoor 80% of meer om vandaag 1 officieel sticker-pakket te verdienen!",
        aiBotActive: "AI-botagent Actief",
        curatingTrivia: "NIEUWE TRIVIA WORDT SAMENGESTELD",
        loaderDesc: "Analyse van transfers, spelerstatistieken en kampioenschappen om 10 gloednieuwe, ultra-nauwkeurige dagelijkse vragen te maken. Bereid je voor!",
        readyTitle: "Ben je klaar om je vaardigheden te testen?",
        questionsTitle: "10 Vragen:",
        questionsDesc: "Zorgvuldig samengestelde multiple-choice trivia, goed of fout, spelersilhouettes en clubtransfergeschiedenissen.",
        timerTitle: "10-Sec Timer:",
        timerDesc: "Meedogenloze countdown voor elke vraag! Denk na, reageer en verzend voordat je tijd om is.",
        rewardsTitle: "Elite Beloningen:",
        rewardsDesc: "Beantwoord minimaal 8 vragen correct (8/10) om een sticker-pakket te winnen. Dagelijks speelbaar!",
        todayStatus: "STATUS VAN VANDAAG",
        rewardedStatus: "🎉 BELOOND (+1 PAKKET)",
        completedStatus: "VOLTOOID",
        alreadyDoneDesc: "Je hebt de dagelijkse quiz van vandaag al voltooid. Nieuwe vragen starten binnenkort op basis van de UTC-servertijd.",
        practiceRun: "Oefenronde (Geen extra pakketten)",
        initiateQuiz: "START DE QUIZ VAN VANDAAG",
        questionTracker: "VRAAG VOORTGANG",
        timeRemaining: "RESTERENDE TIJD (SEC)",
        type: "Type",
        multipleChoice: "Multiple Choice",
        trueOrFalse: "Waar of Niet Waar",
        playerSilhouette: "Spelersilhouet",
        clubTransferLine: "Club Transfergeschiedenis",
        playerAchievementsProfile: "PROFIEL VAN SPELERPRESTATIES",
        seniorTransferHistory: "SENIOR TRANSFERGESCHIEDENIS",
        excellentAnswer: "GEWELDIG ANTWOORD! (+10 PUNTEN)",
        timerExpired: "TIJD OM! HET ANTWOORD WAS",
        wrongAnswer: "FOUT ANTWOORD! HET ANTWOORD WAS",
        challengeConquered: "UITDAGING OVERWONNEN!",
        challengeCompleted: "UITDAGING VOLTOOID",
        date: "DATUM",
        yourPointsEarned: "JE VERDIENDE PUNTEN",
        correctAnswers: "{correctCount} Goede Antwoorden / 10",
        correctAnswersSingular: "{correctCount} Goed Antwoord / 10",
        rewardUnlockedTitle: "BELONING VRIJGESCHAKELD EN TOEGEVOEGD!",
        rewardUnlockedDesc: "Gegarandeerde hoge nauwkeurigheid bereikt! +1 Premium sticker-pakket is automatisch toegevoegd aan je collectie.",
        rewardOnePerDayNote: "* Opmerking: Er is slechts één beloningspakket per dag beschikbaar. Kom morgen terug voor een nieuwe ronde!",
        underThresholdTitle: "ONDER DE VEREISTE LIMIT",
        underThresholdDesc: "Je hebt {correctCount} vragen correct beantwoord. Er zijn minimaal 8 goede antwoorden vereist.",
        underThresholdNote: "Geen grenzen aan leren! Bekijk de voetbalfeiten en klik hieronder op opnieuw proberen om het sticker-pakket te verdienen!",
        sharedSuccess: "SUCCESVOL GEDEELD!",
        copiedClipboard: "GEKOPIEERD NAAR KLEMBORD",
        directShare: "DEEL RESULTATEN DIRECT",
        retryQuiz: "PROBEER OPNIEUW QIUZ",
        bonusClaimed: "🎁 BONUS GECLAIMD: +1 Pakket vandaag toegevoegd!",
        bonusOffer: "🎁 BONUS: Deel resultaten voor +1 extra Pakket!",
        comeBackTomorrow: "Kom morgen terug voor een nieuwe dagelijkse ronde!",
        quizLeaderboard: "QUIZ RANKING",
        liveRankings: "Live Rankings & Historische Records",
        refreshStats: "Statistieken Vernieuwen",
        loading: "Laden...",
        todaysRanks: "Ranglijst van Vandaag",
        allTimeRecords: "All-Time Records",
        searchCollectors: "ZOEK VERZAMELAARS...",
        retrievingLeaderboard: "Live klassement wordt opgehaald...",
        noMatchedPlayers: "Geen verzamelaars gevonden.",
        nobodySubmitted: "Er heeft vandaag nog niemand een score ingediend. Word de eerste op het podium!",
        noRankings: "Geen rangschikkingen geregistreerd.",
        you: "Jij",
        eventsSolved: "Evenementen Opgelost",
        eventsSolvedSingular: "Evenement Opgelost",
        eventsSolvedPlural: "Evenementen Opgelost",
        todaysPoints: "PUNTEN VAN VANDAAG",
        totalPoints: "TOTAAL PUNTEN",
        confirmResetProgress: "Weet je zeker dat je je voortgang van vandaag wilt wissen?",
        yesReset: "JA, RESETTEN",
        cancel: "ANNULEREN",
        resetBtn: "🧪 VOORTGANG VAN VANDAAG WISSEN (TEST)",
        badgeTextSuccess: "🏅 UITDAGING OVERWONNEN! (+1 Sticker-pakket ontgrendeld)",
        badgeTextFailure: "⚡ Leren van de legendes! Oefening baart kunst.",
        correctAnswersShort: "Goed"
    },
    fi: {
        digitalQuizEvent: "Digitaalinen tietovisa",
        dailyFootballQuiz: "PÄIVITTÄINEN JALKAPALLOVISA",
        quizSubtitle: "Vastaa 10 nopeaan kysymykseen, jotka testaavat jalkapallotietoutesi. Kerää vähintään 80 % oikein ja ansaitse 1 virallinen tarrapussi tänään!",
        aiBotActive: "Tekoälybotti aktiivinen",
        curatingTrivia: "LUODAAN UUSIA KYSYMYKSIÄ",
        loaderDesc: "Analysoidaan siirtoja, pelaajatilastoja ja mestaruuksia, jotta saadaan 10 upouutta, erittäin tarkkaa päivittäistä kysymystä. Valmistaudu!",
        readyTitle: "Oletko valmis testaamaan taitosi?",
        questionsTitle: "10 Kysymystä:",
        questionsDesc: "Käsintehtyjä monivalintakysymyksiä, Kyllä tai Ei -kysymyksiä, pelaajasiluetteja ja seurojen siirtohistoriaa.",
        timerTitle: "10 sekunnin ajastin:",
        timerDesc: "Säälimätön lähtölaskenta jokaiselle kysymykselle! Ajattele, reagoi ja lähetä vastauksesi ennen ajan loppumista.",
        rewardsTitle: "Eliittipalkinnot:",
        rewardsDesc: "Vastaa vähintään 8 kysymykseen oikein (8/10) voittaaksesi tarran. Pelattavissa päivittäin!",
        todayStatus: "TÄMÄN PÄIVÄN TILANNE",
        rewardedStatus: "🎉 PALKITUN TILANNE (+1 PUSSI)",
        completedStatus: "VALMIS",
        alreadyDoneDesc: "Olet jo suorittanut tämän päivän tietovisan. Uudet kysymykset alkavat pian UTC-palvelimen aikavyöhykkeen mukaan.",
        practiceRun: "Harjoituskierros (Ei lisäpusseja)",
        initiateQuiz: "ALOITA TÄMÄN PÄIVÄN VISA",
        questionTracker: "KYSYMYKSEN SEURANTA",
        timeRemaining: "AIKAA JÄLJELLÄ (SEK)",
        type: "Tyyppi",
        multipleChoice: "Monivalinta",
        trueOrFalse: "Kyllä tai Ei",
        playerSilhouette: "Pelaajasiluetti",
        clubTransferLine: "Seurasiirtohistoria",
        playerAchievementsProfile: "PELAAJAN SAAVUTUSPROFIILI",
        seniorTransferHistory: "URASIIRTOHISTORIA",
        excellentAnswer: "LOISTAVA VASTAUS! (+10 PISTETTÄ)",
        timerExpired: "AIKA LOPPUI! VASTAUS OLI",
        wrongAnswer: "VÄÄRIN! VASTAUS OLI",
        challengeConquered: "HAASTE VALLOITETTU!",
        challengeCompleted: "HAASTE SUORITETTU",
        date: "PÄIVÄMÄÄRÄ",
        yourPointsEarned: "KERÄTYT PISTEET",
        correctAnswers: "{correctCount} oikein / 10",
        correctAnswersSingular: "{correctCount} oikein / 10",
        rewardUnlockedTitle: "PALKINTO AVATTU JA MYÖNNETTY!",
        rewardUnlockedDesc: "Erinomainen tarkkuus saavutettu! +1 Premium-tarrapussi on lisätty kokoelmaasi automaattisesti.",
        rewardOnePerDayNote: "* Huomautus: Vain yksi palkintopussi myönnetään päivässä. Palaa huomenna uuteen jalkapallovisaan!",
        underThresholdTitle: "TARKKKUUSRAJAN ALAPUOLELLA",
        underThresholdDesc: "Vastasit {correctCount} kysymykseen oikein. Vähintään 8 oikeaa vastausta vaaditaan tarrapussin avaamiseksi.",
        underThresholdNote: "Oppimisella ei ole rajoja! Tutustu jalkapallofaktoihin ja kokeile uudelleen ansaitaksesi tarrapussin!",
        sharedSuccess: "JATTU ONNISTUNEESTI!",
        copiedClipboard: "KOPIOITU LEIKEPÖYDÄLLE",
        directShare: "JAA TULOKSET PAREMMIN",
        retryQuiz: "YRITÄ VISAA UUDELLEEN",
        bonusClaimed: "🎁 BONUS LUNASTETTU: +1 pussi lisätty tänään!",
        bonusOffer: "🎁 BONUS: Jaa tulokset ansaitaksesi +1 extrapussin!",
        comeBackTomorrow: "Palaa huomenna uuteen päivittäiseen visaan!",
        quizLeaderboard: "PISTEPÖRSSI",
        liveRankings: "Live-sijoitukset ja historialliset mestarit",
        refreshStats: "Päivitä tilastot",
        loading: "Ladataan...",
        todaysRanks: "Tämän päivän lista",
        allTimeRecords: "Kaikkien aikojen lista",
        searchCollectors: "ETSI KERÄILIJÖITÄ...",
        retrievingLeaderboard: "Päivitetään tilanteita...",
        noMatchedPlayers: "Hakua vastaavia keräilijöitä ei löytynyt.",
        nobodySubmitted: "Kukaan ei ole vielä lähettänyt pisteitään tänään. Ota kärkipaikka haltuun!",
        noRankings: "Ei vielä sijoituksia.",
        you: "Sinä",
        eventsSolved: "Suoritetut tapahtumat",
        eventsSolvedSingular: "Suoritettu tapahtuma",
        eventsSolvedPlural: "Suoritetut tapahtumat",
        todaysPoints: "TÄMÄN PÄIVÄN PISTEET",
        totalPoints: "KOKONAISPISTEET",
        confirmResetProgress: "Haluatko varmasti nollata tämän päivän edistymisen?",
        yesReset: "KYLLÄ, NOLLAA",
        cancel: "PERUUTA",
        resetBtn: "🧪 NOLLAA TÄMÄN PÄIVÄN EDISTYMINEN (TESTI)",
        badgeTextSuccess: "🏅 HAASTE LÄPÄISTY! (+1 Tarrapaketti avattu)",
        badgeTextFailure: "⚡ Legendoilta oppiminen vie pitkälle! Harjoitus tekee mestarin.",
        correctAnswersShort: "Oikein"
    },
    hr: {
        digitalQuizEvent: "Digitalni Kviz Događaj",
        dailyFootballQuiz: "DNEVNI NOGOMETNI KVIZ",
        quizSubtitle: "Odgovorite na 10 brzih pitanja kako biste testirali svoje nogometno znanje. Osvojite 80% ili više za 1 besplatan službeni paket sličica danas!",
        aiBotActive: "AI Bot Agent je aktivan",
        curatingTrivia: "KREIRANJE NOVIH PITANJA",
        loaderDesc: "Analiziramo transfere, statistiku igrača i prvenstva kako bismo stvorili 10 potpuno novih, ultra preciznih dnevnih pitanja. Pripremite se!",
        readyTitle: "Jeste li spremni testirati svoje vještine?",
        questionsTitle: "10 Pitanja:",
        questionsDesc: "Ručno rađena pitanja s više ponuđenih odgovora, Točno ili Netočno, siluete igrača i povijest transfera.",
        timerTitle: "10 sekundi za odgovor:",
        timerDesc: "Nemilosrdno odbrojavanje za svako pitanje! Razmislite, reagirajte i pošaljite prije nego vrijeme istekne.",
        rewardsTitle: "Elitne nagrade:",
        rewardsDesc: "Osigurajte barem 8 točnih odgovora (8/10) za osvajanje paketa sličica. Igrajte svakodnevno!",
        todayStatus: "STATUS ZA DANAS",
        rewardedStatus: "🎉 NAGRAĐENI (+1 PAKET)",
        completedStatus: "DOVRŠENO",
        alreadyDoneDesc: "Već ste dovršili današnji kviz izazov. Set novih pitanja aktivirat će se uskoro prema UTC vremenu poslužitelja.",
        practiceRun: "Pokusno igranje (Bez dodatnih paketa)",
        initiateQuiz: "POKRENI DANAŠNJI KVIZ",
        questionTracker: "ZAPISNIK PITANJA",
        timeRemaining: "PREOSTALO VRIJEMA (SEK)",
        type: "Vrsta",
        multipleChoice: "Višestruki Izbor",
        trueOrFalse: "Točno ili Netočno",
        playerSilhouette: "Silueta Igrača",
        clubTransferLine: "Povijest Transfera u Klubu",
        playerAchievementsProfile: "PROFIL I POSTIGNUĆA IGRAČA",
        seniorTransferHistory: "SENIORSKA POVIJEST TRANSFERA",
        excellentAnswer: "ODLIČAN ODGOVOR! (+10 BODOVA)",
        timerExpired: "VRIJEME JE ISTEKLO! TOČAN ODGOVOR JEST",
        wrongAnswer: "NETOČNO! TOČAN ODGOVOR JEST",
        challengeConquered: "IZAZOV JE SVALDAN!",
        challengeCompleted: "IZAZOV DOVRŠEN",
        date: "DATUM",
        yourPointsEarned: "OSVOJENI BODOVI",
        correctAnswers: "{correctCount} Točnih odgovora / 10",
        correctAnswersSingular: "{correctCount} Točan odgovor / 10",
        rewardUnlockedTitle: "NAGRADA OTKLJUČANA I DODIJELJENA!",
        rewardUnlockedDesc: "Postignuta visoka točnost! +1 Premium paket sličica automatski je dodan u vašu kolekciju.",
        rewardOnePerDayNote: "* Napomena: Dodjeljuje se samo jedan nagradni paket dnevno. Vratite se sutra za novi krug!",
        underThresholdTitle: "ISPOD PRAGA TOČNOSTI",
        underThresholdDesc: "Odgovorili ste točno na {correctCount} pitanja. Potrebno je najmanje 8 točnih odgovora za otključavanje paketa.",
        underThresholdNote: "Učenju nema kraja! Pregledajte činjenice i kliknite ponovi ispod kako biste osvojili taj paket!",
        sharedSuccess: "USPJEŠNO PODIJELJENO!",
        copiedClipboard: "KOPIRANO U MEĐUMEMORIJU",
        directShare: "IZRAVNO PODIJELI REZULTATE",
        retryQuiz: "RETRY FOOTBALL QUIZ",
        bonusClaimed: "🎁 BONUS PREUZET: +1 Paket dodan danas!",
        bonusOffer: "🎁 BONUS: Podijelite rezultate za +1 dodatni paket!",
        comeBackTomorrow: "Vratite se sutra za novi dnevni kviz!",
        quizLeaderboard: "TABLICA PORETKA",
        liveRankings: "Trenutni poredak i povijesni rekordi",
        refreshStats: "Osvježi statistiku",
        loading: "Učitavanje...",
        todaysRanks: "Današnji rang",
        allTimeRecords: "Svi rekordi",
        searchCollectors: "TRAŽI IGRAČE...",
        retrievingLeaderboard: "Ažuriranje ljestvice poretka...",
        noMatchedPlayers: "Nisu pronađeni odgovarajući skupljači.",
        nobodySubmitted: "Nitko još danas nije poslao rezultate. Budite prvi i osigurajte postolje!",
        noRankings: "Nema rezultata.",
        you: "Vi",
        eventsSolved: "Izazovi riješeni",
        eventsSolvedSingular: "Izazov riješen",
        eventsSolvedPlural: "Izazovi riješeni",
        todaysPoints: "DANAŠNJI BODOVI",
        totalPoints: "UKUPNI BODOVI",
        confirmResetProgress: "Jeste li sigurni da želite potpuno nollirati današnji napredak?",
        yesReset: "DA, RESETIRAJ",
        cancel: "ODUSTANI",
        resetBtn: "🧪 RESETIRAJ PROGRESS (TEST)",
        badgeTextSuccess: "🏅 IZAZOV SVLADAN! (+1 Paket sličica otključan)",
        badgeTextFailure: "⚡ Učimo od legendi! Vježba čini majstora.",
        correctAnswersShort: "Točno"
    },
    ja: {
        digitalQuizEvent: "デジタルクイズイベント",
        dailyFootballQuiz: "デイリー・フットボール・クイズ",
        quizSubtitle: "あなたのサッカー知識を駆使して10問のスピードクイズに回答しましょう。80%以上の正解でステッカーパックが1つもらえます！",
        aiBotActive: "AIボットエージェント稼働中",
        curatingTrivia: "新しい問題を作成中",
        loaderDesc: "移籍情報、選手のスタッツ、リーグ成績等を分析し、高精度の10個の日替わりクイズを生成しています。準備はいいですか？",
        readyTitle: "挑戦する準備はできましたか？",
        questionsTitle: "クイズ10問:",
        questionsDesc: "択一式問題、○✕クイズ、キャリアパスや移籍履歴に紐づく選手特定問題など。",
        timerTitle: "10秒タイマー:",
        timerDesc: "1問あたり10秒のカウントダウン！時間内に決断して回答しましょう。",
        rewardsTitle: "エリート報酬:",
        rewardsDesc: "10問中8問以上（80%）正解でステッカーパックを獲得できます。毎日挑戦可能！",
        todayStatus: "本日のステータス",
        rewardedStatus: "🎉 獲得済み (+1パック)",
        completedStatus: "完了",
        alreadyDoneDesc: "本日のクイズは既に完了しています。UTC時間に基づいて、次のクイズが準備されます。",
        practiceRun: "練習モード（パック獲得なし）",
        initiateQuiz: "本日のクイズを開始する",
        questionTracker: "質問トラッカー",
        timeRemaining: "残り時間（秒）",
        type: "タイプ",
        multipleChoice: "多肢選択",
        trueOrFalse: "○✕クイズ",
        playerSilhouette: "選手シルエット",
        clubTransferLine: "所属クラブ移籍パス",
        playerAchievementsProfile: "選手実績プロフィール",
        seniorTransferHistory: "シニアキャリア移籍履歴",
        excellentAnswer: "素晴らしい回答！ (+10ポイント)",
        timerExpired: "時間切れ！ 正解は",
        wrongAnswer: "不正解！ 正解は",
        challengeConquered: "チャレンジクリア！",
        challengeCompleted: "チャレンジ完了",
        date: "日付",
        yourPointsEarned: "獲得ポイント",
        correctAnswers: "{correctCount} / 10 問正解",
        correctAnswersSingular: "{correctCount} / 10 問正解",
        rewardUnlockedTitle: "報酬アンロック！",
        rewardUnlockedDesc: "素晴らしい成績です！プレミアムステッカーパックが1つコレクションに追加されました。",
        rewardOnePerDayNote: "※報酬は1日1回まで獲得可能です。明日も新たなサッカークイズでお会いしましょう！",
        underThresholdTitle: "アンロック条件未到達",
        underThresholdDesc: "今回の正解は {correctCount} 問でした。パックを獲得するには8問以上正解する必要があります。",
        underThresholdNote: "何度でも挑戦できます！選手データを確認したら、もう一度チャレンジしてパックを手に入れましょう！",
        sharedSuccess: "共有しました！",
        copiedClipboard: "クリップボードにコピーしました",
        directShare: "結果を直接シェアする",
        retryQuiz: "フットボールクイズに再挑戦する",
        bonusClaimed: "🎁 ボーナス獲得: パックが1つ追加されました！",
        bonusOffer: "🎁 ボーナス: 結果をシェアして +1 追加パックを獲得！",
        comeBackTomorrow: "明日の日替わり問題もお楽しみに！",
        quizLeaderboard: "クイズリーダーボード",
        liveRankings: "ライブランキング ＆ 歴代チャンピオン",
        refreshStats: "データを更新する",
        loading: "読み込み中...",
        todaysRanks: "本日のランキング",
        allTimeRecords: "歴代記録",
        searchCollectors: "コレクターを検索...",
        retrievingLeaderboard: "ランキングを更新中...",
        noMatchedPlayers: "該当するプレーヤーは見つかりませんでした。",
        nobodySubmitted: "本日スコアを登録したユーザーはまだいません。あなたが最初の勝者になりましょう！",
        noRankings: "データはありません。",
        you: "あなた",
        eventsSolved: "クリア数",
        eventsSolvedSingular: "クリア数",
        eventsSolvedPlural: "クリア数",
        todaysPoints: "本日の獲得ポイント",
        totalPoints: "総合ポイント",
        confirmResetProgress: "本日のクイズ進捗をリセットしてやり直しますか？",
        yesReset: "はい、リセットする",
        cancel: "キャンセル",
        resetBtn: "🧪 今日の進捗をリセットする (テスト用)",
        badgeTextSuccess: "🏅 チャレンジに勝利しました！(+1 ステッカーパック)",
        badgeTextFailure: "⚡ レジェンドから学びましょう！練習あるのみです。",
        correctAnswersShort: "正解"
    },
    ko: {
        digitalQuizEvent: "디지털 퀴즈 이벤트",
        dailyFootballQuiz: "일일 축구 퀴즈",
        quizSubtitle: "축구 지식을 축적한 10개의 빠른 질문에 답하십시오. 80% 이상 맞히면 공식 스티커 팩 1개를 오늘 드립니다!",
        aiBotActive: "AI 봇 에이전트 활성화됨",
        curatingTrivia: "새로운 문제를 만들고 있습니다",
        loaderDesc: "이적 정보, 선수 통계, 리그 우승 기록을 분석해 10가지 초정밀 일일 퀴즈를 생성합니다. 준비하세요!",
        readyTitle: "실력을 테스트할 준비가 되셨나요?",
        questionsTitle: "10가지 질문:",
        questionsDesc: "객관식 퀴즈, 참/거짓 유형, 선수 실루엣 확인, 소속 클럽 이적 역사 등.",
        timerTitle: "10초 타이머:",
        timerDesc: "매 질문마다 촉박한 카운트다운! 시간 종료 전에 정답을 결정하세요.",
        rewardsTitle: "엘리트 보상:",
        rewardsDesc: "10문항 중 최소 8문항(8/10)을 맞히면 스티커 팩 보상을 획득합니다. 일일 1회 가능!",
        todayStatus: "오늘의 상태",
        rewardedStatus: "🎉 보상 완료 (+1 팩)",
        completedStatus: "완료",
        alreadyDoneDesc: "오늘의 일일 퀴즈를 이미 완료하셨습니다. 서버의 UTC 시간 기준으로 다음 퀴즈가 준비됩니다.",
        practiceRun: "연습 모드 (보상 없음)",
        initiateQuiz: "오늘의 퀴즈 시작하기",
        questionTracker: "질문 트래커",
        timeRemaining: "남은 시간 (초)",
        type: "유형",
        multipleChoice: "객관식",
        trueOrFalse: "참 / 거짓",
        playerSilhouette: "선수 실루엣",
        clubTransferLine: "클럽 이적 커리어",
        playerAchievementsProfile: "선수 업적 프로필",
        seniorTransferHistory: "시니어 이적 내역",
        excellentAnswer: "훌륭한 답변입니다! (+10 포인트)",
        timerExpired: "시간이 초과되었습니다! 정답은 ",
        wrongAnswer: "정답이 아닙니다. 정답은 ",
        challengeConquered: "도전 과제 해결!",
        challengeCompleted: "도전 과제 완료",
        date: "날짜",
        yourPointsEarned: "획득한 포인트",
        correctAnswers: "{correctCount}개 정답 / 10",
        correctAnswersSingular: "{correctCount}개 정답 / 10",
        rewardUnlockedTitle: "보상이 잠금 해제 및 지급되었습니다!",
        rewardUnlockedDesc: "높은 정확도를 달성하셨습니다! 컬렉션 보관함에 +1 프리미엄 스티커 팩이 자동 지급되었습니다.",
        rewardOnePerDayNote: "* 참고: 일일 1개의 퀴즈 보상 팩만 유효합니다. 내일 새로운 정답으로 가득한 퀴즈에 도전하세요!",
        underThresholdTitle: "목표 임계값 미만",
        underThresholdDesc: "이번 도전에서 {correctCount}문제를 맞혔습니다. 보상 팩을 받으려면 8문제 이상 정답을 맞혀야 합니다.",
        underThresholdNote: "배움에는 끝이 없습니다! 지식을 확인하고 아래의 다시 시도 버튼을 클릭해 팩을 가져가세요!",
        sharedSuccess: "보내기 완료!",
        copiedClipboard: "클립보드에 복사되었습니다",
        directShare: "결과 공유하기",
        retryQuiz: "축구 퀴즈 다시 시도",
        bonusClaimed: "🎁 보너스 수령: 오늘 +1팩 추가 완료!",
        bonusOffer: "🎁 보너스: 결과를 공유하고 +1 추가 팩 더 받기!",
        comeBackTomorrow: "내일의 새로운 질문에 도전하세요!",
        quizLeaderboard: "퀴즈 리더보드",
        liveRankings: "실시간 순위 및 역대 명예의 전당",
        refreshStats: "기록 새로고침",
        loading: "불러오는 중...",
        todaysRanks: "오늘의 순위",
        allTimeRecords: "역대 기록",
        searchCollectors: "수집가 검색...",
        retrievingLeaderboard: "순위 정보를 실시간으로 업데이트 중...",
        noMatchedPlayers: "검색과 일치하는 수집가를 찾지 못했습니다.",
        nobodySubmitted: "오늘 점수를 등록한 수집가가 아직 없습니다. 첫 번째 단상에 오르는 수집가가 되어보세요!",
        noRankings: "기록이 없습니다.",
        you: "나",
        eventsSolved: "완료 횟수",
        eventsSolvedSingular: "완료 횟수",
        eventsSolvedPlural: "완료 횟수",
        todaysPoints: "오늘의 포인트",
        totalPoints: "누적 포인트",
        confirmResetProgress: "오늘의 도전 진행 상황을 초기화하시겠습니까?",
        yesReset: "예, 초기화합니다",
        cancel: "취소",
        resetBtn: "🧪 오늘의 퀴즈 진행도 초기화 (테스트용)",
        badgeTextSuccess: "🏅 도전 성공! (+1 공식 스티커 팩 잠금 해제)",
        badgeTextFailure: "⚡ 레전드들의 발자취! 연습을 통해 실력을 길러보세요.",
        correctAnswersShort: "정답"
    },
    el: {
        digitalQuizEvent: "Ψηφιακό Κουίζ Ποδοσφαίρου",
        dailyFootballQuiz: "ΚΑΘΗΜΕΡΙΝΟ ΚΟΥΙΖ ΠΟΔΟΣΦΑΙΡΟΥ",
        quizSubtitle: "Απαντήστε σε 10 γρήγορες ερωτήσεις για να δοκιμάσετε τις ποδοσφαιρικές σας γνώσεις. Πετύχετε 80% ή περισσότερο για να κερδίσετε 1 Επίσημο Πακέτο Αυτοκόλλητων σήμερα!",
        aiBotActive: "AI Bot Agent Ενεργός",
        curatingTrivia: "ΔΗΜΙΟΥΡΓΙΑ ΝΕΩΝ ΕΡΩΤΗΣΕΩΝ",
        loaderDesc: "Αναλύουμε μεταγραφές, στατιστικά παικτών και πρωταθλήματα για να δημιουργήσουμε 10 ολοκαίνουργιες και ακριβείς καθημερινές ερωτήσεις. Ετοιμαστείτε!",
        readyTitle: "Είστε έτοιμοι να δοκιμάσετε τις ικανότητές σας;",
        questionsTitle: "10 Ερωτήσεις:",
        questionsDesc: "Ερωτήσεις πολλαπλής επιλογής, Σωστό ή Λάθος, σιλουέτες παικτών και ιστορικό μεταγραφών συλλόγων.",
        timerTitle: "1ο-Δευτ Χρονόμετρο:",
        timerDesc: "Αμείλικτη αντίστροφη μέτρηση για κάθε ερώτηση! Σκεφτείτε, αντιδράστε και υποβάλετε πριν τελειώσει ο χρόνος.",
        rewardsTitle: "Ελίτ Ανταμοιβές:",
        rewardsDesc: "Εξασφαλίστε τουλάχιστον 8 σωστές απαντήσεις (8/10) για να κερδίσετε ένα πακέτο αυτοκόλλητων. Παίξτε καθημερινά!",
        todayStatus: "ΚΑΤΑΣΤΑΣΗ ΣΗΜΕΡΑ",
        rewardedStatus: "🎉 ΑΝΤΑΜΟΙΒΗ (+1 ΠΑΚΕΤΟ)",
        completedStatus: "ΟΛΟΚΛΗΡΩΘΗΚΕ",
        alreadyDoneDesc: "Έχετε ήδη ολοκληρώσει το σημερινό καθημερινό κουίζ. Οι νέες ερωτήσεις θα ενεργοποιηθούν σύντομα βάσει της ώρας UTC του διακομιστή.",
        practiceRun: "Δοκιμαστικός Γύρος (Χωρίς έξτρα πακέτα)",
        initiateQuiz: "ΕΝΑΡΞΗ ΣΗΜΕΡΙΝΟΥ ΚΟΥΙΖ",
        questionTracker: "ΚΑΤΑΓΡΑΦΗ ΕΡΩΤΗΣΕΩΝ",
        timeRemaining: "ΥΠΟΛΕΙΠΟΜΕΝΟΣ ΧΡΟΝΟΣ (ΔΕΥΤ)",
        type: "Τύπος",
        multipleChoice: "Πολλαπλής Επιλογής",
        trueOrFalse: "Σωστό ή Λάθος",
        playerSilhouette: "Σιλουέτα Παίκτη",
        clubTransferLine: "Ιστορικό Μεταγραφών Συλλόγου",
        playerAchievementsProfile: "ΠΡΟΦΙΛ ΕΠΙΤΕΥΓΜΑΤΩΝ ΠΑΙΚΤΗ",
        seniorTransferHistory: "ΙΣΤΟΡΙΚΟ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΜΕΤΑΓΡΑΦΩΝ",
        excellentAnswer: "ΕΞΑΙΡΕΤΙΚΗ ΑΠΑΝΤΗΣΗ! (+10 ΠΟΝΤΟΙ)",
        timerExpired: "ΛΗΞΗ ΧΡΟΝΟΥ! Η ΑΠΑΝΤΗΣΗ ΗΤΑΝ",
        wrongAnswer: "ΛΑΘΟΣ ΑΠΑΝΤΗΣΗ! Η ΑΠΑΝΤΗΣΗ ΗΤΑΝ",
        challengeConquered: "Η ΠΡΟΚΛΗΣΗ ΚΑΤΑΚΤΗΘΗΚΕ!",
        challengeCompleted: "Η ΠΡΟΚΛΗΣΗ ΟΛΟΚΛΗΡΩΘΗΚΕ",
        date: "ΗΜΕΡΟΜΗΝΙΑ",
        yourPointsEarned: "ΟΙ ΠΟΝΤΟΙ ΠΟΥ ΚΕΡΔΙΣΑΤΕ",
        correctAnswers: "{correctCount} Σωστές Απαντήσεις / 10",
        correctAnswersSingular: "{correctCount} Σωστή Απάντηση / 10",
        rewardUnlockedTitle: "Η ΑΝΤΑΜΟΙΒΗ ΞΕΚΛΕΙΔΩΘΗΚΕ ΚΑΙ ΠΙΣΤΩΘΗΚΕ!",
        rewardUnlockedDesc: "Εξαιρετική ακρίβεια! +1 Premium πακέτο αυτοκόλλητων προστέθηκε αυτόματα στη συλλογή σας.",
        rewardOnePerDayNote: "* Σημείωση: Μόνο ένα πακέτο ανταμοιβής πιστώνεται ανά ημέρα. Επιστρέψτε αύριο για νέο κουίζ!",
        underThresholdTitle: "ΚΑΤΩ ΑΠΟ ΤΟ ΟΡΙΟ ΑΚΡΙΒΕΙΑΣ",
        underThresholdDesc: "Απαντήσατε σωστά σε {correctCount} ερωτήσεις. Απαιτούνται τουλάχιστον 8 σωστές απαντήσεις για το πακέτο.",
        underThresholdNote: "Η μάθηση δεν έχει όρια! Δείτε τα γεγονότα και κάντε κλικ στο 'δοκιμάστε ξανά' για να κερδίσετε το πακέτο!",
        sharedSuccess: "ΚΟΙΝΟΠΟΙΗΘΗΚΕ ΕΠΙΤΥΧΩΣ!",
        copiedClipboard: "ΑΝΤΙΓΡΑΦΗΚΕ ΣΤΟ ΠΡΟΧΕΙΡΟ",
        directShare: "ΑΜΕΣΗ ΚΟΙΝΟΠΟΙΗΣΗ ΑΠΟΤΕΛΕΣΜΑΤΩΝ",
        retryQuiz: "ΔΟΚΙΜΑΣΤΕ ΞΑΝΑ",
        bonusClaimed: "🎁 BONUS ΛΗΦΘΗΚΕ: +1 Πακέτο προστέθηκε σήμερα!",
        bonusOffer: "🎁 BONUS: Κοινοποιήστε τα αποτελέσματα για +1 επιπλέον Πακέτο!",
        comeBackTomorrow: "Επιστρέψτε αύριο για νέες ερωτήσεις!",
        quizLeaderboard: "ΠΙΝΑΚΑΣ ΚΑΤΑΤΑΞΗΣ",
        liveRankings: "Ζωντανές Κατατάξεις & Ιστορικά Ρεκόρ",
        refreshStats: "Ανανέωση Στατιστικών",
        loading: "Φόρτωση...",
        todaysRanks: "Σημερινή Κατάταξη",
        allTimeRecords: "Ρεκόρ Όλων των Εποχών",
        searchCollectors: "ΑΝΑΖΗΤΗΣΗ ΣΥΛΛΕΚΤΩΝ...",
        retrievingLeaderboard: "Ανάκτηση ζωντανής κατάταξης...",
        noMatchedPlayers: "Δεν βρέθηκαν συλλέκτες.",
        nobodySubmitted: "Κανείς δεν έχει υποβάλει σκορ σήμερα ακόμα. Γίνετε ο πρώτος στο βάθρο!",
        noRankings: "Δεν υπάρχουν εγγραφές.",
        you: "Εσείς",
        eventsSolved: "Προκλήσεις που λύθηκαν",
        eventsSolvedSingular: "Πρόκληση που λύθηκε",
        eventsSolvedPlural: "Προκλήσεις που λύθηκαν",
        todaysPoints: "ΣΗΜΕΡΙΝΟΙ ΠΟΝΤΟΙ",
        totalPoints: "ΣΥΝΟΛΙΚΟΙ ΠΟΝΤΟΙ",
        confirmResetProgress: "Είστε σίγουροι ότι θέλετε να μηδενίσετε τη σημερινή πρόοδο;",
        yesReset: "ΝΑΙ, ΜΗΔΕΝΙΣΜΟΣ",
        cancel: "ΑΚΥΡΩΣΗ",
        resetBtn: "🧪 ΜΗΔΕΝΙΣΜΟΣ ΣΗΜΕΡΙΝΗΣ ΠΡΟΟΔΟΥ (TEST)",
        badgeTextSuccess: "🏅 Η ΠΡΟΚΛΗΣΗ ΚΑΤΑΚΤΗΘΗΚΕ! (+1 Πακέτο Αυτοκόλλητων)",
        badgeTextFailure: "⚡ Μαθαίνουμε από τους θρύλους! Η εξάσκηση κάνει τον δάσκαλο.",
        correctAnswersShort: "Σωστά"
    },
    hi: {
        digitalQuizEvent: "डिजिटल क्विज़ इवेंट",
        dailyFootballQuiz: "दैनिक फुटबॉल क्विज़",
        quizSubtitle: "फुटबॉल के अपने ज्ञान का परीक्षण करने के लिए 10 त्वरित प्रश्नों के उत्तर दें। आज 1 आधिकारिक स्टिकर पैक अर्जित करने के लिए 80% या अधिक स्कोर करें!",
        aiBotActive: "एआई बॉट एजेंट सक्रिय है",
        curatingTrivia: "नए प्रश्न तैयार किए जा रहे हैं",
        loaderDesc: "हम दैनिक रूप से 10 नए और सटीक प्रश्न डिजाइन करने के लिए ट्रांसफर, खिलाड़ी के आंकड़े और चैंपियनशिप का विश्लेषण कर रहे हैं। तैयार रहें!",
        readyTitle: "क्या आप अपने कौशल का परीक्षण करने के लिए तैयार हैं?",
        questionsTitle: "10 प्रश्न:",
        questionsDesc: "बहुविकल्पीय प्रश्न, सही या गलत के प्रश्न, खिलाड़ी सिल्हूट और क्लब ट्रांसफर इतिहास।",
        timerTitle: "10-सेकंड टाइमर:",
        timerDesc: "हर प्रश्न के लिए निर्दयी उलटी गिनती! समय समाप्त होने से पहले सोचें, प्रतिक्रिया दें और सबमिट करें।",
        rewardsTitle: "एलीट पुरस्कार:",
        rewardsDesc: "मुफ्त स्टिकर पैक जीतने के लिए कम से कम 8 सही उत्तर (8/10) सुरक्षित करें। दैनिक रूप से खेलने योग्य!",
        todayStatus: "आज की स्थिति",
        rewardedStatus: "🎉 पुरस्कृत (+1 पैक)",
        completedStatus: "पूरा हुवा",
        alreadyDoneDesc: "आपने आज की दैनिक क्विज़ चुनौती पहले ही पूरी कर ली है। सर्वर के यूटीसी समय के आधार पर नए प्रश्न जल्द ही सक्रिय होंगे।",
        practiceRun: "अभ्यास चक्र (कोई अतिरिक्त पैक नहीं)",
        initiateQuiz: "आज की क्विज़ शुरू करें",
        questionTracker: "प्रश्न प्रगति",
        timeRemaining: "बचा हुआ समय (सेकंड)",
        type: "प्रकार",
        multipleChoice: "बहुविकल्पीय",
        trueOrFalse: "सही या गलत",
        playerSilhouette: "खिलाड़ी छवि",
        clubTransferLine: "क्लब स्थानांतरण इतिहास",
        playerAchievementsProfile: "खिलाड़ी उपलब्धि प्रोफ़ाइल",
        seniorTransferHistory: "वरिष्ठ स्थानांतरण इतिहास",
        excellentAnswer: "उत्कृष्ट उत्तर! (+10 अंक)",
        timerExpired: "समय समाप्त! सही उत्तर था",
        wrongAnswer: "गलत उत्तर! सही उत्तर था",
        challengeConquered: "चुनौती जीती!",
        challengeCompleted: "चुनौती पूरी हुई",
        date: "दिनांक",
        yourPointsEarned: "आपके द्वारा अर्जित अंक",
        correctAnswers: "{correctCount} सही उत्तर / 10",
        correctAnswersSingular: "{correctCount} सही उत्तर / 10",
        rewardUnlockedTitle: "पुरस्कार अनलॉक और जमा हुआ!",
        rewardUnlockedDesc: "उच्च सटीकता हासिल की! +1 प्रीमियम स्टिकर पैक स्वचालित रूप से आपके संग्रह में जुड़ गया है।",
        rewardOnePerDayNote: "* नोट: प्रति दिन केवल एक पुरस्कार पैक जमा किया जाता है। कल फिर से खेलने के लिए आएं!",
        underThresholdTitle: "सटीकता सीमा से कम",
        underThresholdDesc: "आपने {correctCount} प्रश्नों के सही उत्तर दिए। मुफ्त पैक को अनलॉक करने के लिए कम से कम 8 सही उत्तरों की आवश्यकता है।",
        underThresholdNote: "सीखने की कोई सीमा नहीं है! फुटबॉल के तथ्यों की समीक्षा करें और फिर से खेलें!",
        sharedSuccess: "सफलतापूर्वक साझा किया गया!",
        copiedClipboard: "क्लिपबोर्ड में कॉपी किया गया",
        directShare: "परिणाम सीधे साझा करें",
        retryQuiz: "फिर से प्रयास करें क्विज़",
        bonusClaimed: "🎁 बोनस दावा किया गया: आज +1 पैक जोड़ा गया है!",
        bonusOffer: "🎁 बोनस: +1 अतिरिक्त पैक पाने के लिए परिणाम साझा करें!",
        comeBackTomorrow: "नए दैनिक सवालों के लिए कल फिर आएं!",
        quizLeaderboard: "क्विज़ लीडरबोर्ड",
        liveRankings: "लाइव रैंकिंग और ऐतिहासिक चैंपियन रिकॉर्ड",
        refreshStats: "आंकड़े रीफ़्रेश करें",
        loading: "लोड हो रहा है...",
        todaysRanks: "आज की रैंकिंग",
        allTimeRecords: "सर्वकालिक रिकॉर्ड",
        searchCollectors: "कलेक्टरों को खोजें...",
        retrievingLeaderboard: "लाइव रैंकिंग अपडेट हो रही है...",
        noMatchedPlayers: "कोई मेल खाता खिलाड़ी नहीं मिला।",
        nobodySubmitted: "आज अभी तक किसी ने अपना स्कोर दर्ज नहीं किया है। पोडियम जीतने वाले पहले व्यक्ति बनें!",
        noRankings: "कोई रिकॉर्ड नहीं है।",
        you: "आप",
        eventsSolved: "हल किए कार्यक्रम",
        eventsSolvedSingular: "हल किया कार्यक्रम",
        eventsSolvedPlural: "हल किए कार्यक्रम",
        todaysPoints: "आज के अंक",
        totalPoints: "कुल अंक",
        confirmResetProgress: "क्या आप वाकई आज की प्रगति को पूरी तरह से रीसेट करना चाहते हैं?",
        yesReset: "हाँ, रीसेट करें",
        cancel: "रद्द करें",
        resetBtn: "🧪 आज की प्रगति रीसेट करें (प्रशिक्षण)",
        badgeTextSuccess: "🏅 चुनौती जीती! (+1 स्टिकर पैक अनलॉक)",
        badgeTextFailure: "⚡ दिग्गजों से सीख रहे हैं! अभ्यास परिपूर्ण बनाता है।",
        correctAnswersShort: "सही"
    },
    da: {
        digitalQuizEvent: "Digital Quiz-begivenhed",
        dailyFootballQuiz: "DAGLIG FODBOLDQUIZ",
        quizSubtitle: "Svar på 10 hurtige spørgsmål designet til at teste din fodboldviden. Få 80% eller mere for at vinde 1 officiel sticker-pakke i dag!",
        aiBotActive: "AI Bot Agent Aktiv",
        curatingTrivia: "Opretter NYE SPØRGSMÅL",
        loaderDesc: "Vi analyserer transfers, spillerstatistikker og mesterskaber for at skabe 10 helt nye, ultra-præcise daglige spørgsmål. Gør dig klar!",
        readyTitle: "Er du klar til at teste dine evner?",
        questionsTitle: "10 Spørgsmål:",
        questionsDesc: "Håndlavet multiple-choice quiz, rigtigt eller forkert, spillersilhuetter og transfershistorik i klubber.",
        timerTitle: "10-Sekunders Timer:",
        timerDesc: "Gnaven nedtælling for hvert spørgsmål! Tænk, reager og send inden din tid løber ud.",
        rewardsTitle: "Elitebelønninger:",
        rewardsDesc: "Få mindst 8 rigtige svar (8/10) for at vinde en sticker-pakke. Kan spilles dagligt!",
        todayStatus: "STATUS FOR I DAG",
        rewardedStatus: "🎉 BELØNNET (+1 PAKKE)",
        completedStatus: "GENNEMFØRT",
        alreadyDoneDesc: "Du har allerede gennemført dagens fodboldquiz. Nye spørgsmål starter snart i forhold til serverens UTC-tid.",
        practiceRun: "Træningsrunde (Ingen ekstra pakker)",
        initiateQuiz: "START DAGENS QUIZ",
        questionTracker: "SPØRGSMÅLSTRACKER",
        timeRemaining: "RESTERENDE TID (SEK)",
        type: "Type",
        multipleChoice: "Multiple Choice",
        trueOrFalse: "Sandt eller Falsk",
        playerSilhouette: "Spillersilhuet",
        clubTransferLine: "Klubbens Transferhistorik",
        playerAchievementsProfile: "SPILLERPROFIL OG PRESTATIONER",
        seniorTransferHistory: "SENIOR TRANSFERHISTORIK",
        excellentAnswer: "FREMRAGENDE SVAR! (+10 POINT)",
        timerExpired: "TIDEN UDLØB! SVARET VAR",
        wrongAnswer: "FORKERT SVAR! SVARET VAR",
        challengeConquered: "UDFORDRINGEN OVERVUNDET!",
        challengeCompleted: "UDFORDRING GENNEMFØRT",
        date: "DATO",
        yourPointsEarned: "DINE OPTJENTE POINT",
        correctAnswers: "{correctCount} Rigtige Svar / 10",
        correctAnswersSingular: "{correctCount} Rigtigt Svar / 10",
        rewardUnlockedTitle: "BELØNNING LÅST OP OG TILFØJET!",
        rewardUnlockedDesc: "Fantastisk præcision opnået! +1 Premium sticker-pakke er automatisk føjet til din samling.",
        rewardOnePerDayNote: "* Bemærk: Hver samler kan kun vinde én belønningspakke om dagen. Vend tilbage i morgen for en ny runde!",
        underThresholdTitle: "UNDER NØJAGTIGHEDSGRÆNSEN",
        underThresholdDesc: "Du svarede rigtigt på {correctCount} spørgsmål. Der kræves mindst 8 rigtige svar for at låse pakken op.",
        underThresholdNote: "Der er ingen grænser for at lære! Se fakta og klik på prøv igen nedenfor for at vinde pakken!",
        sharedSuccess: "DELET MED SUCCES!",
        copiedClipboard: "KOPIERET TIL UTKLIPSHOLDER",
        directShare: "DEL RESULTATER DIREKTE",
        retryQuiz: "PRØV FODBOLDQUIZ IGEN",
        bonusClaimed: "🎁 BONUS MODTAGET: +1 Pakke tilføjet i dag!",
        bonusOffer: "🎁 BONUS: Del dit resultat for at få +1 ekstra pakke!",
        comeBackTomorrow: "Vend tilbage i morgen for helt nye daglige udfordringer!",
        quizLeaderboard: "QUIZ HIGHSCORE",
        liveRankings: "Live-rangliste & Historiske rekorder",
        refreshStats: "Opdater statistik",
        loading: "Indlæser...",
        todaysRanks: "Dagens rangliste",
        allTimeRecords: "Alle tidsrekorder",
        searchCollectors: "SØG EFTER SAMLERE...",
        retrievingLeaderboard: "Henter live rangliste...",
        noMatchedPlayers: "Ingen matchende samlere fundet.",
        nobodySubmitted: "Ingen har sendt deres score i dag. Bliv den første til at tage føringen på podiet!",
        noRankings: "Ingen registrerede resultater.",
        you: "Dig",
        eventsSolved: "Udfordringer overvundet",
        eventsSolvedSingular: "Udfordring overvundet",
        eventsSolvedPlural: "Udfordringer overvundet",
        todaysPoints: "DAGENS POINT",
        totalPoints: "SAMLEDE POINT",
        confirmResetProgress: "Er du sikker på, du vil nulstille din dags fremskridt?",
        yesReset: "JA, NULSTIL",
        cancel: "FORTRYD",
        resetBtn: "🧪 NULSTIL DAGENS FREMSKRIDT (TEST)",
        badgeTextSuccess: "🏅 UDFORDRING OVERVUNDET! (+1 Sticker-pakkelås op)",
        badgeTextFailure: "⚡ Vi lærer af legenderne! Øvelse gør mester.",
        correctAnswersShort: "Rigtige"
    },
    bs: {
        digitalQuizEvent: "Digitalni Kviz Događaj",
        dailyFootballQuiz: "DNEVNI FUDBALSKI KVIZ",
        quizSubtitle: "Odgovorite na 10 brzih pitanja kako biste testirali svoje fudbalsko znanje. Osvojite 80% ili više za 1 besplatan zvanični paket sličica danas!",
        aiBotActive: "AI Bot Agent je aktivan",
        curatingTrivia: "KREIRANJE NOVIH PITANJA",
        loaderDesc: "Analiziramo transfere, statistiku igrača i prvenstva kako bismo stvorili 10 potpuno novih, ultra preciznih dnevnih pitanja. Pripremite se!",
        readyTitle: "Jeste li spremni testirati svoje vještine?",
        questionsTitle: "10 Pitanja:",
        questionsDesc: "Ručno rađena pitanja sa više ponuđenih odgovora, Tačno ili Netačno, siluete igrača i historija transfera u klubu.",
        timerTitle: "10 sekundi za odgovor:",
        timerDesc: "Nemilosrdno odbrojavanje za svako pitanje! Razmislite, reagujte i pošaljite prije nego vrijeme istekne.",
        rewardsTitle: "Elitne nagrade:",
        rewardsDesc: "Osigurajte barem 8 tačnih odgovora (8/10) za osvajanje paketa sličica. Igrajte svakodnevno!",
        todayStatus: "STATUS ZA DANAS",
        rewardedStatus: "🎉 NAGRAĐENI (+1 PAKET)",
        completedStatus: "ZAVRŠENO",
        alreadyDoneDesc: "Već ste završili današnji kviz izazov. Set novih pitanja aktivirat će se uskoro prema UTC vremenu servera.",
        practiceRun: "Probno igranje (Bez dodatnih paketa)",
        initiateQuiz: "POKRENI DANAŠNJI KVIZ",
        questionTracker: "ZAPISNIK PITANJA",
        timeRemaining: "PREOSTALO VRIJEME (SEK)",
        type: "Vrsta",
        multipleChoice: "Višestruki Izbor",
        trueOrFalse: "Tačno ili Netačno",
        playerSilhouette: "Silueta Igrača",
        clubTransferLine: "Istorija kluba",
        playerAchievementsProfile: "PROFIL I POSTIGNUĆA IGRAČA",
        seniorTransferHistory: "SENIORSKA ISTORIJA TRANSFERA",
        excellentAnswer: "ODLIČAN ODGOVOR! (+10 BODOVA)",
        timerExpired: "VRIJEME JE ISTEKLO! TAČAN ODGOVOR JE",
        wrongAnswer: "NETAČNO! TAČAN ODGOVOR JE",
        challengeConquered: "IZAZOV JE SAVLADAN!",
        challengeCompleted: "IZAZOV ZAVRŠEN",
        date: "DATUM",
        yourPointsEarned: "OSVOJENI BODOVI",
        correctAnswers: "{correctCount} Tačnih odgovora / 10",
        correctAnswersSingular: "{correctCount} Tačan odgovor / 10",
        rewardUnlockedTitle: "NAGRADA OTKLJUČANA I DODIJELJENA!",
        rewardUnlockedDesc: "Postignuta visoka tačnost! +1 Premium paket sličica automatski je dodan u vašu kolekciju.",
        rewardOnePerDayNote: "* Napomena: Dodjeljuje se samo jedan nagradni paket dnevno. Vratite se sutra za novu rundu!",
        underThresholdTitle: "ISPOD PRAGA TAČNOSTI",
        underThresholdDesc: "Odgovorili ste tačno na {correctCount} pitanja. Potrebno je najmanje 8 tačnih odgovora za otključavanje paketa.",
        underThresholdNote: "Učenju nema kraja! Pregledajte činjenice i kliknite ponovi ispod kako biste osvojili taj paket!",
        sharedSuccess: "USPJEŠNO PODIJELJENO!",
        copiedClipboard: "KOPIRANO U MEĐUMEMORIJU",
        directShare: "DIREKTNO PODIJELI REZULTATE",
        retryQuiz: "PROBAJ KVIZ PONOVO",
        bonusClaimed: "🎁 BONUS PREUZET: +1 Paket dodan danas!",
        bonusOffer: "🎁 BONUS: Podijelite rezultate za +1 dodatni paket!",
        comeBackTomorrow: "Vratite se sutra za novi dnevni kviz!",
        quizLeaderboard: "TABLICA PORETKA",
        liveRankings: "Trenutni poredak i historijski rekordi",
        refreshStats: "Osvježi statistiku",
        loading: "Učitavanje...",
        todaysRanks: "Današnji rang",
        allTimeRecords: "Svi rekordi",
        searchCollectors: "PRETRAGA SKUPLJAČA...",
        retrievingLeaderboard: "Ažuriranje tabele poretka...",
        noMatchedPlayers: "Nisu pronađeni odgovarajući skupljači.",
        nobodySubmitted: "Niko još danas nije poslao rezultate. Budite prvi i osigurajte postolje!",
        noRankings: "Nema rezultata.",
        you: "Vi",
        eventsSolved: "Izazovi riješeni",
        eventsSolvedSingular: "Izazov riješen",
        eventsSolvedPlural: "Izazovi riješeni",
        todaysPoints: "DANAŠNJI BODOVI",
        totalPoints: "UKUPNI BODOVI",
        confirmResetProgress: "Jeste li sigurni da želite potpuno poništiti današnji napredak?",
        yesReset: "DA, PONIŠTI",
        cancel: "ODUSTANI",
        resetBtn: "🧪 PONIŠTI DANAŠNJI NAPREDAK (TEST)",
        badgeTextSuccess: "🏅 IZAZOV SAVLADAN! (+1 Paket sličica otključan)",
        badgeTextFailure: "⚡ Učimo od legendi! Vježba čini savršenstvo.",
        correctAnswersShort: "Tačnih"
    },
    sr: {
        digitalQuizEvent: "Digitalni Kviz Događaj",
        dailyFootballQuiz: "DNEVNI FUDBALSKI KVIZ",
        quizSubtitle: "Odgovorite na 10 brzih pitanja kako biste testirali svoje fudbalsko znanje. Osvojite 80% ili više za 1 besplatan zvanični paket sličica danas!",
        aiBotActive: "AI Bot Agent je aktivan",
        curatingTrivia: "KREIRANJE NOVIH PITANJA",
        loaderDesc: "Analiziramo transfere, statistiku igrača i prvenstva kako bismo stvorili 10 potpuno novih, ultra preciznih dnevnih pitanja. Pripremite se!",
        readyTitle: "Da li ste spremni da testirate svoje veštine?",
        questionsTitle: "10 Pitanja:",
        questionsDesc: "Ručno rađena pitanja sa više ponuđenih odgovora, Tačno ili Netačno, siluete igrača i istorija transfera u klubu.",
        timerTitle: "10 sekundi za odgovor:",
        timerDesc: "Nemilosrdno odbrojavanje za svako pitanje! Razmislite, reagujte i pošaljite pre nego što vreme istekne.",
        rewardsTitle: "Elitne nagrade:",
        rewardsDesc: "Osigurajte barem 8 tačnih odgovora (8/10) za osvajanje paketa sličica. Igrajte svakodnevno!",
        todayStatus: "STATUS ZA DANAS",
        rewardedStatus: "🎉 NAGRAĐENI (+1 PAKET)",
        completedStatus: "ZAVRŠENO",
        alreadyDoneDesc: "Već ste završili današnji kviz izazov. Set novih pitanja aktiviraće se uskoro prema UTC vremenu servera.",
        practiceRun: "Probno igranje (Bez dodatnih paketa)",
        initiateQuiz: "POKRENI DANAŠNJI KVIZ",
        questionTracker: "ZAPISNIK PITANJA",
        timeRemaining: "PREOSTALO VREME (SEK)",
        type: "Vrsta",
        multipleChoice: "Višestruki Izbor",
        trueOrFalse: "Tačno ili Netačno",
        playerSilhouette: "Silueta Igrača",
        clubTransferLine: "Istorija kluba",
        playerAchievementsProfile: "PROFIL I POSTIGNUĆA IGRAČA",
        seniorTransferHistory: "SENIORSKA ISTORIJA TRANSFERA",
        excellentAnswer: "ODLIČAN ODGOVOR! (+10 BODOVA)",
        timerExpired: "VREME JE ISTEKLO! TAČAN ODGOVOR JE",
        wrongAnswer: "NETAČNO! TAČAN ODGOVOR JE",
        challengeConquered: "IZAZOV JE SAVLADAN!",
        challengeCompleted: "IZAZOV ZAVRŠEN",
        date: "DATUM",
        yourPointsEarned: "OSVOJENI BODOVI",
        correctAnswers: "{correctCount} Tačnih odgovora / 10",
        correctAnswersSingular: "{correctCount} Tačan odgovor / 10",
        rewardUnlockedTitle: "NAGRADA OTKLJUČANA I DODELJENA!",
        rewardUnlockedDesc: "Postignuta visoka tačnost! +1 Premium paket sličica automatski je dodat u vašu kolekciju.",
        rewardOnePerDayNote: "* Napomena: Dodeljuje se samo jedan nagradni paket dnevno. Vratite se sutra za novu rundu!",
        underThresholdTitle: "ISPOD PRAGA TAČNOSTI",
        underThresholdDesc: "Odgovorili ste tačno na {correctCount} pitanja. Potrebno je najmanje 8 tačnih odgovora za otključavanje paketa.",
        underThresholdNote: "Učenju nema kraja! Pregledajte činjenice i kliknite ponovo ispod kako biste osvojili taj paket!",
        sharedSuccess: "USPŠENO PODELJENO!",
        copiedClipboard: "KOPIRANO U PRIVREMENU MEMORIJU",
        directShare: "DIREKTNO PODELI REZULTATE",
        retryQuiz: "PROBAJ KVIZ PONOVO",
        bonusClaimed: "🎁 BONUS PREUZET: +1 Paket dodat danas!",
        bonusOffer: "🎁 BONUS: Podelite rezultate za +1 dodatni paket!",
        comeBackTomorrow: "Vratite se sutra za novi dnevni kviz!",
        quizLeaderboard: "TABELA PORETKA",
        liveRankings: "Trenutni poredak i istorijski rekordi",
        refreshStats: "Osveži statistiku",
        loading: "Učitavanje...",
        todaysRanks: "Današnji rang",
        allTimeRecords: "Svi rekordi",
        searchCollectors: "PRETRAGA SKUPLJAČA...",
        retrievingLeaderboard: "Ažuriranje tabele poretka...",
        noMatchedPlayers: "Nisu pronađeni odgovarajući sakupljači.",
        nobodySubmitted: "Niko još danas nije poslao rezultate. Budite prvi i osigurajte postolje!",
        noRankings: "Nema rezultata.",
        you: "Vi",
        eventsSolved: "Izazovi rešeni",
        eventsSolvedSingular: "Izazov rešen",
        eventsSolvedPlural: "Izazovi rešeni",
        todaysPoints: "DANAŠNJI BODOVI",
        totalPoints: "UKUPNI BODOVI",
        confirmResetProgress: "Da li ste sigurni da želite potpuno poništiti današnji napredak?",
        yesReset: "DA, PONIŠTI",
        cancel: "ODUSTANI",
        resetBtn: "🧪 PONIŠTI DANAŠNJI NAPREDAK (TEST)",
        badgeTextSuccess: "🏅 IZAZOV SAVLADAN! (+1 Paket sličica otključan)",
        badgeTextFailure: "⚡ Učimo od legendi! Vežba čini savršenstvo.",
        correctAnswersShort: "Tačnih"
    }
};
